<template>
  <div class="container animate__animated animate__fadeIn animate__faster">
    <div class="row">
      <div
        v-if="loading"
        class="col-12 mt-5 text-center">
        <Spinner/>
      </div>
      <div
        v-else
        class="col-12">
        <button
          v-if="manager"
          class="float-start btn btn-sm btn-primary mt-2"
          @click="goBack">
          <i class="fa fa-chevron-left"/>
          Select a TM
        </button>
        <!-- Active Display Listing -->
        <div v-if="records && records.length">
          <div class="text-center text-muted mt-3">
            <h5>Active Displays</h5>
          </div>
          <div
            class="my-3 position-relative"
            style="max-width: 31em; margin: 0 auto;">
            <input
              class="form-control"
              placeholder="Search Customers..."
              v-model="query"
              type="text">
            <i
              v-if="query.length"
              class="fa fa-times text-danger animate__animated animate__fadeInRight animate__faster"
              style="position: absolute; top: 10px; right: 10px; cursor: pointer;"
              @click="clearQuery"/>
          </div>
          <Customer
            v-for="c in customers"
            :key="c.id"
            :customer="c"
            :records="records"
            :items="items"/>    
        </div>
        <!-- No Displays Handler -->
        <div
          v-if="(!records || records.length == 0) || (!customers || customers.length == 0)"
          class="mt-5 text-center animate__animated animate__fadeIn animate__faster">
          <h4 class="text-muted">No Records</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import Customer from './Customer.vue';
  import Spinner from '../../../../../../global/Spinner.vue';
  import { ref, computed, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { customerSearch } from '../../js/displayTracking';
  import { managerRoles } from '../../../../../../../shared/roles';

  // Initialize
  const store = useStore()

  // Data
  const query = ref('')

  // LifeCycle
  onMounted(()=>{
    if(selectedTm.value){
      store.dispatch('displayTrackingSetLoading', true)
      store.dispatch('getTmCustomers', selectedTm.value)
    }
    store.dispatch('displayTrackingGetRepRecords', selectedTm.value?.eclipse_user_id)
  })

  // Methods
  const clearQuery = ()=>{
    query.value = ''
  }

  const goBack = ()=>{
    store.dispatch('displayTrackingSetView', 'tmSelect')
  }

  // Computed
  const records = computed(()=>{
    return store.getters.displayTrackingRecords
  })

  const items = computed(()=>{
    return store.getters.displayTrackingItems
  })

  const customers = computed(()=>{
    if(store.getters.customerData?.customer_list){
      const customerIds = _.uniq(_.map(records.value, 'customerId'))
      const list =  _.filter(store.getters.customerData.customer_list, c => customerIds.includes(c.id))
      const lowerQuery = query.value.toLowerCase()
      if(lowerQuery.length){
        return customerSearch(list, lowerQuery)
      }
      return list
    }
  })

  const selectedTm = computed(()=>{
    return store.getters.displayTrackingSelectedTm || store.getters.activeTm
  })

  const loading = computed(()=>{
    return store.getters.displayTrackingLoading
  })

  const manager = computed(()=>{
    return managerRoles.includes(store.getters.user.role)
  })
</script>